// Whether a set of permission codes grants a required code: an exact match, or - when deep - `prefix.*` for each
// dot-prefix of the required code (`deposit.*`, `deposit.create.*` for `deposit.create.wire`). Bare `deposit`,
// `*` and `deposit.create.wire.*` do not match, and codes are case-sensitive.
//
// The one frontend copy of the rule the server applies in PermissionCodeMatcher. The user store's hasFeatureAccess
// and the role screens both call it, so what the UI offers and what the server allows cannot drift apart.
export const permissionCodesGrant = (grantedCodes, requiredCode, deep = true) => {
  const codes = grantedCodes || []
  if (codes.includes(requiredCode)) return true
  if (deep !== true) return false

  const parts = requiredCode.split('.')
  let prefix = ''
  for (let i = 1; i < parts.length; i++) {
    prefix += parts[i - 1] + '.'
    if (codes.includes(prefix + '*')) return true
  }
  return false
}
